// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1jBek","disabled":"FileBtn_disabled__RXfhL","warn":"FileBtn_warn__2FxOQ","fade":"FileBtn_fade__1mZrS"};